import { Device } from '../../installation/forms'
import { DeviceStatus, BatteryTrainingMode } from '../../installation/api'
import { DeviceError, getDeviceErrorsDetails } from '../../advanced-settings/utils/get-device-errors-details'

/**
 * Parse the device status and the errors/warning derived from the status code into props for device status icons.
 * For non-paired devices, status is always "unknown".
 * The "ok" device status has priority over errors/warnings from the error code.
 */
export const getDeviceParsedStatus = (
  device: Device | null,
  showDetailedErrors: boolean,
  batteryTrainingMode: BatteryTrainingMode
): {
  status: DeviceStatus
  errors: DeviceError[]
} => {
  if (!device) {
    return {
      status: 'unknown',
      errors: [],
    }
  }

  const { isPaired, deviceStatus } = device

  if (!isPaired || deviceStatus === 'unknown') {
    return {
      status: 'unknown',
      errors: [],
    }
  }

  if (deviceStatus === 'ok') {
    return {
      status: 'ok',
      errors: [],
    }
  }

  const deviceErrorDetails = getDeviceErrorsDetails(device, batteryTrainingMode, showDetailedErrors)

  if (!deviceErrorDetails) {
    return {
      status: 'unknown',
      errors: [],
    }
  }

  const { numberOfErrors, numberOfWarnings, errorsDetails } = deviceErrorDetails

  // Only warnings
  if (numberOfErrors === 0 && numberOfWarnings > 0) {
    return {
      status: 'warning',
      errors: errorsDetails,
    }
  }

  if (numberOfErrors > 0 || deviceStatus === 'error') {
    return {
      status: 'error',
      errors: errorsDetails,
    }
  }

  return {
    status: 'unknown',
    errors: [],
  }
}
